import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../reducers";
import { useActions } from "../../../../../actions";
import * as Actions from "../../../../../actions/account";
import * as Estimations from "../../../../../actions/estimation";
import {
    GWT_GEN2_STRATEGY,
    minContributionAmount,
    otherIndustryId,
    AllianzLifeCarrierDetail, USA, stateDropDown, OTHER_VALUE, GWTVersionEnum, AccountType,
} from "../../../../../constants";
import moment from "moment";
import AllianzAlert from "../../component/AllianzAlert";
import IncomeAlert from "../../component/IncomeAlert";
import { asDbDateTimeFormat, DATE_FORMAT_DOB_SAVE, getCurrentYear } from "../../../../../utils/dateUtils";
import numeral from "numeral";
import {
	PhysicianAndMedicalDetailsStyle,
} from "../EnrollmentApplication/Style";
import { scroller } from "react-scroll";
import KickOut from "../../component/EnrollmentHome/KickOut";
import PersonalDetailFormikContent from "./PersonalDetailFormikContent";
import PersonalDetailValidate from "./PersonalDetailValidate";
import CommonFieldFunction from "./CommonFieldFunction";
import { formatSSN } from "./PersonalDetailUtils";
import PersonalDetailFieldObj from "./PersonalDetailFieldObj";
import UpdateEmailReqPopUp from "./UpdateEmailReqPopUp";
import { incomeDetailsColArr } from "./PersonalDetailFormikContent";
import { convertToNumber } from "../EnrollmentApplication/Utilities";
import { isNfIulCase } from "../../../../../utils/commonFunc";
import { politicalRelationsInitValue } from "./ProfileFormFields/PoliticalRelations";

const initVal = {
	proofExpiryYear: 0,
	proofExpiryMonth: 0,
	gender: "",
	immigrationStatus: "",
	residenceInHomeCountry: "",
	currentlyEmployed: "",
	currentlyEmployedSelf: "",
	marriageStatus: "",
	employedTime: 0,
	industryId: 0,
	occupationId: 0,
    healthType: "",
    parentsAreIncomeEarner: "",
};

const PersonalDetailFormV2 = (props: {
	setNextStep: Function,
	setActionItem: Function,
	isFromClientDetail?: boolean,
	clientDetail?: any,
	setPersonalDetailRef?: Function,
	setIsPersonalFormDirty?: Function,
	setIsFormSubmitting?: Function,
	setCarrierValAlert?: Function,
	setValidationError?: Function,
	setIsDocumentAddress?: Function,
	getClientDetail?: Function,
	urlClientId?: string,
	ssnFlag?: boolean
    filterAutoSavePayload?: Function
    autoSaveEnable?: boolean,
}) => {
	const classes = PhysicianAndMedicalDetailsStyle();
	const {
		setNextStep,
		isFromClientDetail,
		setPersonalDetailRef,
		setIsPersonalFormDirty,
		setIsFormSubmitting,
		setCarrierValAlert,
		setActionItem,
		setValidationError,
		getClientDetail,
        urlClientId,
        ssnFlag,
        filterAutoSavePayload,
        autoSaveEnable = true
	} = props;
	const accountActions = useActions(Actions);
	const estimationActions = useActions(Estimations);
	const { setIsDocumentAddress } = props;

	let userData = useSelector((state: RootState) => state.profile);
	let { user: { role, participant }, parentPortal } = useSelector((state: RootState) => state.auth);
    if(parentPortal){
        role = 4
    }
    let user = props.clientDetail;
    if (userData.role === AccountType.Individual || userData.role === AccountType.Multilife) {
        user = userData;
    }
	const { client } = user;
	const clientPolicy = client && client.clientPolicies.length > 0 && client.clientPolicies[0];

	const conditionalRequired = !(role === 1 || role === 2 || role === 4);
	const [selfEmployed, setSelfEmployed] = React.useState(false);
	const [currentlyEmployed, setCurrentlyEmployed] = React.useState<string>("");
	const [fullTimeEmployee, setFullTimeEmployee] = React.useState<number>(1);
	const [carrierId, setCarrierId] = React.useState<number | null>(null);
	const [openAlert, setOpenAlert] = React.useState(false);
	const [allianzId, setAllianzId] = React.useState<number | null>(null);
	const [carrierName, setCarrierName] = React.useState<string | undefined>("");
	const [minVal, setMinVal] = React.useState(minContributionAmount);
	const [ageSelected, setAgeSelected] = React.useState(false);
	const [incomeAlertOpen, setIncomeAlertOpen] = React.useState(false);
	const [proofExpired, setProofExpired] = React.useState(false);
	const [nationalLifeId, setNationalLifeId] = React.useState<number | null>(null);
	const [isNationalLife, setIsNationalLife] = React.useState<boolean>(false);
	const [isAllianzLife, setIsAllianzLife] = React.useState<boolean>(false);
	const [minAge, setMinAge] = React.useState<number>(25);
	const [strategySlug, setStrategySlug] = React.useState("");
	const [labelsActive, setLabelsActive] = React.useState<any[]>([]);
    const isNfIul = isNfIulCase((clientPolicy && clientPolicy.strategy && clientPolicy.strategy.id) as number, strategySlug);
	const currentYear = getCurrentYear();
	const personalDetailSubmit = React.useRef<any>();
	const proofExpireRef: any = useRef(null);
	const personalDetailForm: any = React.useRef<any>(null);
	const [isFormSubmit, setIsFormSubmit] = React.useState<boolean>(false);
	const [openKickOutPopup, setOpenKickOutPopup] = useState(false);
	const [fullTimeSelected, setFullTimeSelected] = useState(0);
	const [isMarried, setIsMarried] = useState(false);
	const [isEmployed, setIsEmployed] = useState(false);
	const [provideCorrectEmailPopUp, setProvideCorrectEmailPopUp] = useState(false);
	const [isParentEarner, setIsParentEarner] = React.useState<boolean>(false);
	const [saveRequest, sendSaveRequest] = React.useState<any>(Math.random());
	const [formValues, setFormValues] = React.useState<any>({});
	const [isIndustryOther, setIsIndustryOther] = React.useState(false);
	const [serverError, setServerError] = React.useState(false);
	const clientSigned = (clientPolicy && clientPolicy.enrollment && (clientPolicy.enrollment.clientSigned || clientPolicy.enrollment.envelopeId)) ? 1 : 0; // check envelopId generated too
    const checkEmployeeIdStateValue = obj => obj.name === clientPolicy.employeeIdState;
    const theEmployeeIdStateValue = stateDropDown.some(checkEmployeeIdStateValue) ? clientPolicy && clientPolicy.employeeIdState : "";
    const [employeeIdStateValue, setEmployeeIdStateValue] = React.useState<string>(theEmployeeIdStateValue);
    const [birthCountryValue, setBirthCountryValue] = React.useState<string>(client && client.birthCountry);
	const [middleNameExist, setMiddleNameExist] = React.useState(false);
    const checkBirthStateValue = obj => obj.name === client.birthState;
    const theBirthStateValue = stateDropDown.some(checkBirthStateValue) ? client.birthState : "";
	const [birthStateValue, setBirthStateValue] = React.useState<string>(theBirthStateValue);
	const checkApplicationStateValue = obj => obj.name === clientPolicy.applicationState;
	const theApplicationStateValue = stateDropDown.some(checkApplicationStateValue) ? clientPolicy.applicationState : "Nevada";
	const [applicationStateValue, setApplicationStateValue] = React.useState<string>(theApplicationStateValue);
    const checkStateValue = obj => obj.name === client.state;
    const theStateValue = stateDropDown.some(checkStateValue) ? client.state : "";
    const [stateValue, setStateValue] = React.useState<string>(theStateValue);
	const [dualCitizenshipValue, setDualCitizenshipValue] = React.useState("");
	const [countryCitizenshipValue, setCountryCitizenshipValue] = React.useState(clientPolicy && clientPolicy.countryCitizenship);
	const [otherCitizenshipValue, setOtherCitizenshipValue]= React.useState(clientPolicy && clientPolicy.otherCitizenship);
    const [currentResidenceCountryValue, setCurrentResidenceCountryValue] = React.useState<string>(null || USA);
    const isGiftor = participant && participant.subType  == "Giftor"
	const getAllianzCarrierDetails = async () => {
		const allianzData = await accountActions.getAllianzDetails();
		if (allianzData && allianzData.allianzLife && allianzData.allianzLife.id) {
			setAllianzId(allianzData.allianzLife.id);
		}
	};
	const getNatioanlLifeCarrierDetails = async () => {
		const nationalLifeDate = await accountActions.getNationalLifeDetails();
		if (nationalLifeDate && nationalLifeDate.nationalLife) {
			setNationalLifeId(nationalLifeDate.nationalLife.id);
		}
	};

	const scrollUp = async (id) => {
		setIsFormSubmit(false);
		scroller.scrollTo(id, {
			duration: 800,
			delay: 0,
			smooth: "easeInOutQuart",
			offset: -200,
		});
		return await accountActions.setSnackBarMessage(false, `Drivers license has been expired`);
	};
	const [initialValues, setInitialValues] = React.useState<any>(initVal);
	let dob = user && user.client && user.client.dob;
	
    const isGWTGen2 = (clientPolicy && clientPolicy.strategyId === GWT_GEN2_STRATEGY);
    const isGWTGenV2 = (user && user.client && user.client.gwtVersion === GWTVersionEnum.Two);
    const financiallyDependent: boolean = clientPolicy && clientPolicy.financiallyDependent;
    const gwtV2FD = isGWTGenV2 ? !financiallyDependent : true;
	useEffect(() => {
		let proofExpireDate = clientPolicy && clientPolicy.employeeIdExpireDate;
		let proofExpiryYear = 0;
		let proofExpiryMonth = 0;
		if (proofExpireDate) {
			let proofExpireDateArr = proofExpireDate.split("-");
			proofExpiryYear = Number(proofExpireDateArr[0]);
			proofExpiryMonth = Number(proofExpireDateArr[1]);
		}
		let formVal: any = {
			proofExpiryYear: proofExpiryYear,
			proofExpiryMonth: proofExpiryMonth,
		};
		const highRanking = clientPolicy && clientPolicy.clientSourceOfFund && clientPolicy && clientPolicy.clientSourceOfFund.highRanking
		const greenCardExpiryDate = clientPolicy && clientPolicy.greenCardExpiryDate;
        const greenCardExpiryYear = moment(greenCardExpiryDate).format('YYYY');
        const greenCardExpiryMonth = moment(greenCardExpiryDate).format('M');

        const visaExpiryDate = clientPolicy && clientPolicy.visaExpiryDate;
        const visaExpiryYear = moment(visaExpiryDate).format('YYYY');
        const visaExpiryMonth = moment(visaExpiryDate).format('M');

		if (client) {
			formVal = {
				...formVal,
				firstName: user.firstName || "",
				middleName: user.middleName || "",
				lastName: user.lastName || "",
				cellPhone: user.phoneNumber || "",
				email: user.email || "",
				mnNotRequired: user.mnNotRequired || false,
				usCitizen: !!(clientPolicy && clientPolicy.usCitizen),
                identityType: (clientPolicy && clientPolicy.identityType),
                nonUsCitizen: clientPolicy && clientPolicy.nonUsCitizen,
                applicationState: isNfIul ? clientPolicy && clientPolicy.applicationState : (clientPolicy && clientPolicy.applicationState ? clientPolicy.applicationState : "Nevada"),
				identityId: clientPolicy && clientPolicy.employeeIdNumber || "",
				employeeSSN: formatSSN(client.employeeSSN || ""),
				blotSSN: client.blotSSN || "",
                birthState: (client && client.birthCountry === USA) ? {
                    key: theBirthStateValue,
                    name: theBirthStateValue,
                    title: theBirthStateValue,
                } : theBirthStateValue || "",
                birthCountry: (client && client.birthCountry) ? {
                    key: client && client.birthCountry,
                    name: client && client.birthCountry,
                    title: client && client.birthCountry,
                } : client && client.birthCountry || "",
				workPhoneNumber: client.workPhoneNumber || "",
				homePhone: client.homePhone || "",
				gender: client && client.gender || "",
				dob: asDbDateTimeFormat(client.dob, DATE_FORMAT_DOB_SAVE),
				age: moment().diff(asDbDateTimeFormat(client.dob, DATE_FORMAT_DOB_SAVE), "years") || client.age,
				street: client.street || "",
				city: client.city || "",
                state: {
                    key: theStateValue,
                    name: theStateValue,
                    title: theStateValue,
                },
				zipCode: client.zipCode || "",
				isDocumentAddress: !!(clientPolicy && clientPolicy.isDocumentAddress),
				selfEmployed: (clientPolicy && clientPolicy.selfEmployed || clientPolicy && clientPolicy.currentlyEmployed === "SELF_EMPLOYED"),
                currentlyEmployed: isGWTGenV2 ? (clientPolicy && clientPolicy.currentlyEmployed) : isGWTGen2 ? "Other" : clientPolicy && clientPolicy.currentlyEmployed || "FULL_TIME",
				currentlyEmployedSelf: clientPolicy && clientPolicy.currentlyEmployedSelf || "FULL_TIME",
				fullTimeEmployee: clientPolicy && clientPolicy.fullTimeEmployee,
				howLongInUS: clientPolicy && clientPolicy.howLongInUS || "",
				countryCitizenship: clientPolicy && clientPolicy.countryCitizenship || countryCitizenshipValue,
				immigrationStatus: clientPolicy && clientPolicy.immigrationStatus || "",
				greenCardNo: clientPolicy && clientPolicy.greenCardNo || "",
				greenCardExpiryMonth :greenCardExpiryMonth || "",
                greenCardExpiryYear : greenCardExpiryYear|| "",
				typeOfVisaPlanHeld: clientPolicy && clientPolicy.typeOfVisaPlanHeld || "",
				visaExpiryMonth : visaExpiryMonth || "",
                visaExpiryYear : visaExpiryYear || "",
				typeOfVisaHeld: clientPolicy && clientPolicy.typeOfVisaHeld || "",
				immigrationStatusOther: clientPolicy && clientPolicy.immigrationStatusOther || "",
				residenceInHomeCountry: (clientPolicy && clientPolicy.residenceInHomeCountry && clientPolicy && clientPolicy.residenceInHomeCountry.toString()) || "0",
				residenceInHomeCountryExplain: clientPolicy && clientPolicy.residenceInHomeCountryExplain || "",
				employer: clientPolicy.employer ? clientPolicy.employer : (clientPolicy.company && clientPolicy.company.groupType === "Corporation") ? clientPolicy.company.companyName : "",
				employedTime: clientPolicy && clientPolicy && clientPolicy && clientPolicy.employedTime || "",
				annualIncome: (clientPolicy.annualIncome && numeral(clientPolicy.annualIncome).value() > 0 && Number(clientPolicy.annualIncome).toString()) || "",
				annualIncome1: (clientPolicy && clientPolicy.annualIncome1 && Number(clientPolicy && clientPolicy.annualIncome1).toString()) || "",
				annualIncome2: (clientPolicy && clientPolicy.annualIncome2 && Number(clientPolicy && clientPolicy.annualIncome2).toString()) || "",
				householdAnnualIncome: (clientPolicy && clientPolicy.householdAnnualIncome && Number(clientPolicy && clientPolicy.householdAnnualIncome).toString()) || "", //spouse annual income
				householdNetWorth: (clientPolicy && clientPolicy.householdNetWorth && Number(clientPolicy && clientPolicy.householdNetWorth).toString()) || (clientPolicy.netWorth && Number(clientPolicy.netWorth).toString()) || "",
                spouseIncome: ((clientPolicy && clientPolicy.marriageStatus === "Single") && (clientPolicy && clientPolicy.spouseIncome === "" || clientPolicy && clientPolicy.spouseIncome === null)) ? "0" : (clientPolicy && clientPolicy.spouseIncome && Number(clientPolicy && clientPolicy.spouseIncome).toString()) || "",
				householdLiquidAssets: (clientPolicy && clientPolicy.householdLiquidAssets && Number(clientPolicy && clientPolicy.householdLiquidAssets).toString()) || "",
				householdAnnualExpenses: (clientPolicy && clientPolicy.householdAnnualExpenses && Number(clientPolicy && clientPolicy.householdAnnualExpenses).toString()) || "",
				healthType: clientPolicy && clientPolicy.healthType || "",
                employeeIdState: {
                    key: theEmployeeIdStateValue,
                    name: theEmployeeIdStateValue,
                    title: theEmployeeIdStateValue,
                },
				netWorth: (clientPolicy.netWorth && numeral(clientPolicy.netWorth).value() > 0 && Number(clientPolicy.netWorth).toString()) || "",
				employerContribution: clientPolicy && clientPolicy.employerContribution || 0,
				contributionAmount: clientPolicy && clientPolicy.issuedContribution || clientPolicy && clientPolicy.contributionAmount || "",
				marriageStatus: (clientPolicy && clientPolicy.marriageStatus) || "", // income details new columns starts here
                spouse: (clientPolicy && clientPolicy.trustDetails && clientPolicy.trustDetails.spouse && clientPolicy.trustDetails.spouse.trim()) || "",
                usingSpouseIncome: isGWTGen2 ? "0" : clientPolicy && (typeof clientPolicy.usingSpouseIncome === "number") ? clientPolicy.usingSpouseIncome + "" : "0",
				//spouseIncome: (client.spouseIncome && Number(client.spouseIncome).toString()) || "",
				indIncomeLastYearAnnualSalary: (clientPolicy && clientPolicy.annualIncome && numeral(clientPolicy && clientPolicy.annualIncome).value() > 0 && Number(clientPolicy && clientPolicy.annualIncome).toString()) || "",
				indIncomeLastYearDividends: (clientPolicy && clientPolicy.indIncomeLastYearDividends && numeral(clientPolicy && clientPolicy.indIncomeLastYearDividends).value() > 0 && Number(clientPolicy && clientPolicy.indIncomeLastYearDividends).toString()) || "",
				indIncomeLastYearOtherIncome: (clientPolicy && clientPolicy.indIncomeLastYearOtherIncome && numeral(clientPolicy && clientPolicy.indIncomeLastYearOtherIncome).value() > 0 && Number(clientPolicy && clientPolicy.indIncomeLastYearOtherIncome).toString()) || "0",
				indIncomeLastYearTotal: (clientPolicy && clientPolicy.indIncomeLastYearTotal && numeral(clientPolicy && clientPolicy.indIncomeLastYearTotal).value() > 0 && Number(clientPolicy && clientPolicy.indIncomeLastYearTotal).toString()) || "",
				indIncome1YearsPriorAnnualSalary: (clientPolicy && clientPolicy.annualIncome1 && numeral(clientPolicy && clientPolicy.annualIncome1).value() > 0 && Number(clientPolicy && clientPolicy.annualIncome1).toString()) || "",
				indIncome1YearsPriorDividends: (clientPolicy && clientPolicy.indIncome1YearsPriorDividends && numeral(clientPolicy && clientPolicy.indIncome1YearsPriorDividends).value() > 0 && Number(clientPolicy && clientPolicy.indIncome1YearsPriorDividends).toString()) || "",
				indIncome1YearsPriorOtherIncome: (clientPolicy && clientPolicy.indIncome1YearsPriorOtherIncome && numeral(clientPolicy && clientPolicy.indIncome1YearsPriorOtherIncome).value() > 0 && Number(clientPolicy && clientPolicy.indIncome1YearsPriorOtherIncome).toString()) || "",
				indIncome1YearsPriorTotal: (clientPolicy && clientPolicy.indIncome1YearsPriorTotal && numeral(clientPolicy && clientPolicy.indIncome1YearsPriorTotal).value() > 0 && Number(clientPolicy && clientPolicy.indIncome1YearsPriorTotal).toString()) || "",
				indIncome2YearsPriorAnnualSalary: (clientPolicy && clientPolicy.annualIncome2 && numeral(clientPolicy && clientPolicy.annualIncome2).value() > 0 && Number(clientPolicy && clientPolicy.annualIncome2).toString()) || "",
				indIncome2YearsPriorDividends: (clientPolicy && clientPolicy.indIncome2YearsPriorDividends && numeral(clientPolicy && clientPolicy.indIncome2YearsPriorDividends).value() > 0 && Number(clientPolicy && clientPolicy.indIncome2YearsPriorDividends).toString()) || "",
				indIncome2YearsPriorOtherIncome: (clientPolicy && clientPolicy.indIncome2YearsPriorOtherIncome && numeral(clientPolicy && clientPolicy.indIncome2YearsPriorOtherIncome).value() > 0 && Number(clientPolicy && clientPolicy.indIncome2YearsPriorOtherIncome).toString()) || "",
				indIncome2YearsPriorTotal: (clientPolicy && clientPolicy.indIncome2YearsPriorTotal && numeral(clientPolicy.indIncome2YearsPriorTotal).value() > 0 && Number(clientPolicy.indIncome2YearsPriorTotal).toString()) || "",
				indOtherIncomeDetail: clientPolicy && clientPolicy.indOtherIncomeDetail || "",
				houseHoldIncomeLastYearAnnualSalary: (clientPolicy && clientPolicy.householdAnnualIncome && numeral(clientPolicy && clientPolicy.householdAnnualIncome).value() > 0 && Number(clientPolicy && clientPolicy.householdAnnualIncome).toString()) || "",
				houseHoldIncomeLastYearDividends: (clientPolicy && clientPolicy.houseHoldIncomeLastYearDividends && numeral(clientPolicy && clientPolicy.houseHoldIncomeLastYearDividends).value() > 0 && Number(clientPolicy && clientPolicy.houseHoldIncomeLastYearDividends).toString()) || "",
				houseHoldIncomeLastYearOtherIncome: (clientPolicy && clientPolicy.houseHoldIncomeLastYearOtherIncome && numeral(clientPolicy && clientPolicy.houseHoldIncomeLastYearOtherIncome).value() > 0 && Number(clientPolicy && clientPolicy.houseHoldIncomeLastYearOtherIncome).toString()) || "",
				houseHoldIncomeLastYearTotal: (clientPolicy && clientPolicy.houseHoldIncomeLastYearTotal && numeral(clientPolicy && clientPolicy.houseHoldIncomeLastYearTotal).value() > 0 && Number(clientPolicy && clientPolicy.houseHoldIncomeLastYearTotal).toString()) || "",
				houseHoldIncome1YearsPriorAnnualSalary: (clientPolicy && clientPolicy.houseHoldIncome1YearsPriorAnnualSalary && numeral(clientPolicy && clientPolicy.houseHoldIncome1YearsPriorAnnualSalary).value() > 0 && Number(clientPolicy && clientPolicy.houseHoldIncome1YearsPriorAnnualSalary).toString()) || "",
				houseHoldIncome1YearsPriorDividends: (clientPolicy && clientPolicy.houseHoldIncome1YearsPriorDividends && numeral(clientPolicy && clientPolicy.houseHoldIncome1YearsPriorDividends).value() > 0 && Number(clientPolicy && clientPolicy.houseHoldIncome1YearsPriorDividends).toString()) || "",
				houseHoldIncome1YearsPriorOtherIncome: (clientPolicy && clientPolicy.houseHoldIncome1YearsPriorOtherIncome && numeral(clientPolicy && clientPolicy.houseHoldIncome1YearsPriorOtherIncome).value() > 0 && Number(clientPolicy && clientPolicy.houseHoldIncome1YearsPriorOtherIncome).toString()) || "",
				houseHoldIncome1YearsPriorTotal: (clientPolicy && clientPolicy.houseHoldIncome1YearsPriorTotal && numeral(clientPolicy && clientPolicy.houseHoldIncome1YearsPriorTotal).value() > 0 && Number(clientPolicy && clientPolicy.houseHoldIncome1YearsPriorTotal).toString()) || "",
				houseHoldIncome2YearsPriorAnnualSalary: (clientPolicy && clientPolicy.houseHoldIncome2YearsPriorAnnualSalary && numeral(clientPolicy && clientPolicy.houseHoldIncome2YearsPriorAnnualSalary).value() > 0 && Number(clientPolicy && clientPolicy.houseHoldIncome2YearsPriorAnnualSalary).toString()) || "",
				houseHoldIncome2YearsPriorDividends: (clientPolicy && clientPolicy.houseHoldIncome2YearsPriorDividends && numeral(clientPolicy && clientPolicy.houseHoldIncome2YearsPriorDividends).value() > 0 && Number(clientPolicy && clientPolicy.houseHoldIncome2YearsPriorDividends).toString()) || "",
				houseHoldIncome2YearsPriorOtherIncome: (clientPolicy && clientPolicy.houseHoldIncome2YearsPriorOtherIncome && numeral(clientPolicy && clientPolicy.houseHoldIncome2YearsPriorOtherIncome).value() > 0 && Number(clientPolicy && clientPolicy.houseHoldIncome2YearsPriorOtherIncome).toString()) || "",
				houseHoldIncome2YearsPriorTotal: (clientPolicy && clientPolicy.houseHoldIncome2YearsPriorTotal && numeral(clientPolicy && clientPolicy.houseHoldIncome2YearsPriorTotal).value() > 0 && Number(clientPolicy && clientPolicy.houseHoldIncome2YearsPriorTotal).toString()) || "",
				houseHoldOtherIncomeDetail: clientPolicy && clientPolicy.houseHoldOtherIncomeDetail || "",
                parentsAreIncomeEarner: isGWTGenV2 ? (clientPolicy && clientPolicy.parentsAreIncomeEarner === 1 ? "1" : "0") : isGWTGen2 ? "1" : "0",
				occupation: clientPolicy && clientPolicy.occupation || "",
				industryId: clientPolicy && clientPolicy.industryId || null,
				occupationId: clientPolicy && clientPolicy.occupationId || null,
				otherOccupation: clientPolicy && clientPolicy.otherOccupation || "",
				occupationDetail: clientPolicy && clientPolicy.occupationDetail || "",
				employerAddress: clientPolicy && clientPolicy.employerAddress || "",
				highRanking: highRanking,
				// individualHighRanking: individualHighRanking,
                USBasedCompany: clientPolicy && clientPolicy.USBasedCompany,
				workInIndustries: clientPolicy && clientPolicy.clientSourceOfFund && clientPolicy && clientPolicy.clientSourceOfFund.workInIndustries,
				workIndDesc: !!(clientPolicy && clientPolicy.clientSourceOfFund && clientPolicy && clientPolicy.clientSourceOfFund.workInIndustries) && clientPolicy.clientSourceOfFund.workIndDesc || "" ,
				countryOfOrigin: clientPolicy && clientPolicy.clientSourceOfFund && clientPolicy && clientPolicy.clientSourceOfFund.countryOfOrigin || "",
				sourceOfFunds: clientPolicy && clientPolicy.clientSourceOfFund && clientPolicy && clientPolicy.clientSourceOfFund.sourceOfFunds || "",
				countrySourceOfWealth: clientPolicy && clientPolicy.clientSourceOfFund && clientPolicy && clientPolicy.clientSourceOfFund.countrySourceOfWealth || "",
				whereTheyProceed: clientPolicy && clientPolicy.clientSourceOfFund && clientPolicy && clientPolicy.clientSourceOfFund.whereTheyProceed || "",
				otherIndustry: clientPolicy && clientPolicy.otherIndustry || "",
                currentResidenceCountry: { key: USA, name: USA, title: USA },
				otherCitizenship: (clientPolicy && clientPolicy.otherCitizenship) || (dualCitizenshipValue || ""),
				dualCitizen: !!(clientPolicy && clientPolicy.dualCitizen),
                // Discrepancy Fields
                addressDiscrepancyDescription: clientPolicy && clientPolicy.addressDiscrepancyDescription || "",
                dobMatchOnDocument: !!(clientPolicy && clientPolicy.dobMatchOnDocument),
                dobDiscrepancyDescription: clientPolicy && clientPolicy.dobDiscrepancyDescription || "",
                nameMatchOnDocument: !!(clientPolicy && clientPolicy.nameMatchOnDocument),
                nameDiscrepancyDescription: clientPolicy && clientPolicy.nameDiscrepancyDescription || "",
                politicalRelations: clientPolicy && clientPolicy.clientSourceOfFund && Array.isArray( clientPolicy.clientSourceOfFund.politicalRelations && clientPolicy.clientSourceOfFund.politicalRelations) && clientPolicy.clientSourceOfFund.politicalRelations.length > 0 ? clientPolicy.clientSourceOfFund.politicalRelations : (highRanking ? [politicalRelationsInitValue] : []),

            };
		}
		if (client) {
			setInitialValues(formVal);
		}
	}, [client,clientPolicy, user]);





	React.useEffect(() => {
		if (proofExpired && isFormSubmit && proofExpireRef && proofExpireRef.current) {
			scrollUp(proofExpireRef.current.id);
		}
	}, [proofExpired, isFormSubmit]);

	React.useEffect(() => {
		if (isNationalLife) {
			setMinAge(18); //for National Life Carrier MIN AGE is 18;
		}
	}, [isNationalLife]);

	React.useEffect(() => {
		if (isAllianzLife) {
			setMinAge(18); //for National Life Carrier MIN AGE is 18;
		}
	}, [isAllianzLife]);

	React.useEffect(() => {
		if (isNfIul) {
			setMinAge(18); //for isNfIul Carrier MIN AGE is 18;
		}
	}, [isNfIul]);

	React.useEffect(() => {
		if (nationalLifeId && carrierId && nationalLifeId === carrierId && strategySlug === "kaizen") {
			setIsNationalLife(true);
		}
	}, [nationalLifeId, carrierId]);

	React.useEffect(() => {
		if (allianzId && carrierId && allianzId === carrierId && strategySlug === "kaizen") { //if Allianz Life and strategy is Kaizen
			setIsAllianzLife(true);
		}
	}, [allianzId, carrierId]);

	React.useEffect(() => {
		if (typeof setCarrierValAlert === "function") {
			setCarrierValAlert(openAlert);
		}
	}, [openAlert]);

	useEffect(() => {
		if (personalDetailSubmit.current && typeof setPersonalDetailRef === "function") {
			setPersonalDetailRef(personalDetailSubmit);
		}
	}, [personalDetailSubmit.current]);

	useEffect(() => {
		if (!isFromClientDetail) {
			accountActions.getProfileDetails();
		}
		getAllianzCarrierDetails().then(() => {
		});
		getNatioanlLifeCarrierDetails().then(() => {
		});
	}, []);

	React.useEffect(() => {
		getEstimation().then(() => {
		});
	}, []);

	useEffect(() => {
		if (client) {
			setMiddleNameExist(user.mnNotRequired || false);
			setSelfEmployed(!!(clientPolicy && clientPolicy.selfEmployed));
			setCurrentlyEmployed(clientPolicy && clientPolicy.currentlyEmployed || "");
			setFullTimeEmployee(clientPolicy && clientPolicy.fullTimeEmployee);
			setFullTimeSelected(clientPolicy && clientPolicy.currentlyEmployed === "FULL_TIME" ? 1 : 0);
			setIsMarried(clientPolicy && clientPolicy.marriageStatus === "Married");
            const currentlyEmployedGWT = isGWTGenV2 ? (gwtV2FD ? (clientPolicy && (clientPolicy.currentlyEmployed === "FULL_TIME" || clientPolicy.currentlyEmployed === "PART_TIME" || clientPolicy.currentlyEmployed === "SELF_EMPLOYED")) : false) : clientPolicy && (clientPolicy.currentlyEmployed === "FULL_TIME" || clientPolicy.currentlyEmployed === "PART_TIME" || clientPolicy.currentlyEmployed === "SELF_EMPLOYED" || clientPolicy.currentlyEmployed === "NO" || clientPolicy.currentlyEmployed === "RETIRED");
            setIsEmployed(currentlyEmployedGWT);
			setIsIndustryOther(clientPolicy && clientPolicy.industryId === otherIndustryId);
		}
		if (clientPolicy && clientPolicy.carrier && clientPolicy.carrier.id) {
			setCarrierId(clientPolicy && clientPolicy.carrier && clientPolicy.carrier.id);
			setCarrierName(clientPolicy && clientPolicy.carrier && clientPolicy.carrier.carrierName);
		}
		if (clientPolicy && clientPolicy.strategy && clientPolicy.strategy.slug) {
			setStrategySlug(clientPolicy.strategy.slug);
		}

		if (clientPolicy && clientPolicy.employeeIdExpireDate) {
			const expireDate = moment(new Date(clientPolicy.employeeIdExpireDate));
			const currentDate = moment(new Date());
			const daysLeft = expireDate.diff(currentDate, "days");
			if (daysLeft <= 0) {
				setProofExpired(true);
			}
		}
	}, [client]);

    useEffect(() => {
        if(client && client.birthCountry === undefined){
            setBirthCountryValue(USA);
        } else if(client && client.birthCountry && birthCountryValue === undefined){
            setBirthCountryValue(client.birthCountry);
        } else if(birthCountryValue !== USA){
            setBirthStateValue("");
        }
    }, [client, birthCountryValue]);

	React.useEffect(() => {
		if (personalDetailForm && personalDetailForm.current && personalDetailForm.current.dirty && autoSaveEnable) {
			let values: any = personalDetailForm && personalDetailForm.current && personalDetailForm.current.values;
			if (
				((Number(values["age"]) || Number(values["age"]) === 0) && (Number(values["age"]) < minAge ||
					Number(values["age"]) > 65))
				|| (Number(values["age"]) < 0)
			) {
				values.age = 0;
			}
			if (values.dob === undefined) {
                values.dob = dob;
            }
            setBirthCountryValue(typeof values.birthCountry === "object" ? values.birthCountry && values.birthCountry.name : values.birthCountry);
            saveMe(values);
            setFormValues(values);
        }
	}, [personalDetailForm && personalDetailForm.current && personalDetailForm.current.values, saveRequest, stateValue, middleNameExist]);

	const getEstimation = async () => {
		if (client) {
			getContributionAmount({
				contributionAmount: 0,
				age: client.age,
				rating: clientPolicy && clientPolicy.healthType,
				gender: client && client.gender,
			});
		}
	};

	const getContributionAmount = (data: any) => {
		setTimeout(async () => {
			let isMinRequiredError = clientPolicy && clientPolicy.company && clientPolicy.company.groupType === "Corporation";
			let employerContributionValue: any = 0;
			if (clientPolicy && clientPolicy.employerContribution && numeral(clientPolicy.employerContribution).value() > 0 && props.clientDetail && props.clientDetail.role === 6) {
				employerContributionValue = clientPolicy.employerContribution;
			}
			let estimatorData: any = await estimationActions.getInvitedClientEstimates({
				age: data.age || minAge,
				gender: data.gender === 1 ? "Male" : "Female",
				rating: (data && data.rating) || "Standard",
				contribution: numeral(data.contributionAmount).value() + numeral(employerContributionValue).value() + "",
				strategySlug: (clientPolicy && clientPolicy.strategy && clientPolicy.strategy.slug) || "",
				carrierName: (clientPolicy && clientPolicy.carrier && clientPolicy.carrier.carrierName) || "",
				isMinRequiredError,
			});
			if (estimatorData && estimatorData.payload && estimatorData.payload.minContributionAmount) {
				setMinVal(estimatorData && estimatorData.payload && estimatorData.payload.minContributionAmount);
			}
			if (!isMinRequiredError) {
				setMinVal(0);
			}
		}, 500);
	};

	let contributionType: string | undefined = (clientPolicy && clientPolicy.company && clientPolicy.company.contributionType) || undefined;
	let showEmployerContribution: boolean = true;
	let showClientContribution: boolean = true;

	if ((contributionType === "EMPLOYER_ONLY")) {
		showEmployerContribution = true;
		showClientContribution = false;
	} else if ((contributionType === "PARTICIPANT_ONLY")) {
		showEmployerContribution = false;
		showClientContribution = true;
	} else if ((contributionType === "COMBINE_CONTRIBUTION")) {
		showEmployerContribution = true;
		showClientContribution = true;
	}

	const isCorporation: boolean = !!(clientPolicy && clientPolicy.company && clientPolicy.company.groupType === "Corporation");

    let fieldObj = PersonalDetailFieldObj.fieldObj(conditionalRequired, setBirthCountryValue, birthCountryValue, clientSigned, isNfIul, applicationStateValue, setApplicationStateValue);
    const fieldObj12 = PersonalDetailFieldObj.fieldObj12(conditionalRequired, clientSigned, setBirthStateValue, birthStateValue);
	const fieldObj14 = PersonalDetailFieldObj.fieldObj14(conditionalRequired, clientSigned, dualCitizenshipValue, setDualCitizenshipValue)

    if (birthCountryValue === USA) {
        fieldObj = [...fieldObj, ...fieldObj12];
    }

	const fieldObj1 = PersonalDetailFieldObj.fieldObj1(conditionalRequired, getContributionAmount, setProvideCorrectEmailPopUp, isFromClientDetail,middleNameExist, setMiddleNameExist);

	const setAnticipatedAge = (date, setValue, formValues) => {
		const age = moment().diff(date, "years");
		setAgeSelected(age && (age >= minAge && age <= 65) ? true : false);
		getContributionAmount({
			contributionAmount: 0,
			age: age,
			rating: formValues && formValues.healthType,
			gender: formValues && formValues.gender,
		});
		setValue("age", age);
	};

	const fieldObj4 = PersonalDetailFieldObj.fieldObj4(conditionalRequired, setAnticipatedAge, sendSaveRequest);
    const fieldObj7 = PersonalDetailFieldObj.fieldObj7(conditionalRequired, setProofExpired, setEmployeeIdStateValue, employeeIdStateValue, clientSigned);
	let fieldObj2 = PersonalDetailFieldObj.fieldObj2(conditionalRequired, setStateValue, stateValue, clientSigned);
	let fieldObj8: any = PersonalDetailFieldObj.fieldObj8(conditionalRequired, carrierName, setCountryCitizenshipValue);
	const fieldObj10: any = PersonalDetailFieldObj.fieldObj10(conditionalRequired, setCurrentResidenceCountryValue, currentResidenceCountryValue, clientSigned);
	// const fieldObj11: any = PersonalDetailFieldObj.fieldObj11();
	const greenCardExpiryFieldObj = PersonalDetailFieldObj.greenCardExpiryFieldObj();
	const visaExpiryFieldObj = PersonalDetailFieldObj.visaExpiryFieldObj();
	// const fieldObj11: any = PersonalDetailFieldObj.fieldObj11();
	if (carrierName === AllianzLifeCarrierDetail.name) {
		fieldObj2 = [...fieldObj2, ...fieldObj10];
		fieldObj8 = [...fieldObj8];
	}
	const fieldObj9 = PersonalDetailFieldObj.fieldObj9(conditionalRequired, isNfIul);
	let isGiCorpIncomeCond: boolean = !!fullTimeEmployee;
    const fieldObj3 = PersonalDetailFieldObj.fieldObj3(isGiCorpIncomeCond, conditionalRequired, currentYear, strategySlug, nationalLifeId, carrierId, sendSaveRequest, currentlyEmployed, isEmployed);
	const fieldObj6 = PersonalDetailFieldObj.fieldObj6(conditionalRequired, client, ageSelected, getContributionAmount);

	const getFieldFocusValue = (name: string) => {
		let findResult: any = labelsActive.find((label: any) => {
			return label.name === name;
		});
		if (!findResult) {
			return false;
		}
		return findResult.value;
	};

	const CommonField = (
		filedProps,
		action: {
			handleChange?: Function,
			handleBlur: Function,
			values?: any,
			errors?: any,
			touched?: any,
			setFieldValue: any
		},
	) => {
		return (
			<CommonFieldFunction filedProps={filedProps}
								 action={action}
								 conditionalRequired={conditionalRequired}
								 role={role}
								 setActionItem={setActionItem}
								 client={client}
								 labelsActive={labelsActive}
								 setLabelsActive={setLabelsActive}
								 clientSigned={clientSigned}
								 getFieldFocusValue={getFieldFocusValue}

			/>);
	};

	/* Validations of fields set */
	let keysValidation = {};
    let fieldobj9 = [
        {
            name: "indIncomeLastYearAnnualSalary",
            isRequired: isEmployed,
            type: "number",
        },
        {
            name: "indIncomeLastYearOtherIncome",
            isRequired: isEmployed,
            type: "number",
        },
        {
            name: "indOtherIncomeDetail",
            isRequired: true,
            type: "string",
        },
        {
            name: "netWorth",
            isRequired: isEmployed,
            type: "number",
        },
    ];
    let fieldobj10 = [
    {
    	name: "householdNetWorth",
    	isRequired: true,
    	type: "number",
    },
    {
    	name: "spouseIncome",
    	isRequired: true,
    	type: "number",
    },
    {
    	name: "householdLiquidAssets",
    	isRequired: true,
    	type: "number",
    },
    {
    	name: "householdAnnualExpenses",
    	isRequired: true,
    	type: "number",
    },
    ];

	let validationObj = [
		...fieldObj1,
        ...fieldObj4,
        ...fieldObj,
		{
			name: "currentlyEmployed",
            isRequired: (isGWTGenV2 && financiallyDependent) ? false : conditionalRequired && !(isCorporation),
			type: "string",
		},
		{
			name: "marriageStatus",
			isRequired: conditionalRequired && !isMarried,
			type: "string",
		},
        {
            name: "spouse",
            isRequired: isMarried,
            type: "string",
        },
		{
			name: "usingSpouseIncome",
			isRequired: conditionalRequired && isMarried,
			type: "string",
		},
		{
			name: "employer",
            isRequired: conditionalRequired && isEmployed,
			type: "string",
		}, {
			name: "employedTime",
            isRequired: conditionalRequired && isEmployed,
			type: "string",
		}, {
			name: "occupation",
			isRequired: conditionalRequired && isEmployed && isIndustryOther,
			type: "string",
		},
		{
			name: "industryId",
			isRequired: conditionalRequired && isEmployed,
			type: "number",
		}, {
			name: "occupationId",
			isRequired: conditionalRequired && isEmployed && !isIndustryOther,
			type: "number",
		}, {
			name: "otherOccupation",
			isRequired: conditionalRequired && isEmployed && isIndustryOther,
			type: "string",
		}, {
			name: "occupationDetail",
            isRequired: conditionalRequired && isEmployed,
			type: "string",
        }, {
            name: "employerAddress",
            isRequired: conditionalRequired && isEmployed,
            type: "string",
        },
		{
			name: "parentsAreIncomeEarner",
			isRequired: (conditionalRequired && currentlyEmployed && currentlyEmployed === "Other" && isParentEarner && !isAllianzLife),
			type: "string",
		}];

    if (!isCorporation) {
		if (isGWTGenV2 && financiallyDependent) {
			validationObj = [...validationObj];
		} else {
			validationObj = [...validationObj, ...fieldobj9, ...fieldobj10];
		}
    }

    if (!isGWTGen2) {
        validationObj.push(
                {
                    name: "USBasedCompany",
                    isRequired: conditionalRequired,
                    type: "number",
                },
                // {
                //     name: "highRanking",
                //     isRequired: conditionalRequired,
                //     type: "number",
                // },
                {
                    name: "highRanking",
                    isRequired: conditionalRequired,
                    type: "number",
                },
                {
                    name: "workInIndustries",
                    isRequired: conditionalRequired,
                    type: "number",
                }
        );
    }

	keysValidation = PersonalDetailValidate(validationObj, keysValidation, isFromClientDetail, minAge, fieldObj9, fieldObj8,
		fieldObj2, strategySlug, client, ageSelected, minVal,
		showClientContribution, fieldObj6, fieldObj7, props, visaExpiryFieldObj, greenCardExpiryFieldObj, isGiftor);

	const personalDetailSchema = Yup.object().shape(keysValidation);

	let kickOutDetail = {
		groupAdminEmail: (clientPolicy && clientPolicy.agent && clientPolicy.agent.user && clientPolicy.agent.user.email) || "",
		groupAdminPhone: (clientPolicy && clientPolicy.agent && clientPolicy.agent.user && clientPolicy.agent.user.phoneNumber) || "",
		groupAdminFullName: (clientPolicy && clientPolicy.agent && clientPolicy.agent.user && clientPolicy.agent.user.firstName + " " + clientPolicy.agent.user.lastName) || "",
		strategyName: (clientPolicy && clientPolicy.strategy && clientPolicy.strategy.name) || "",
	};
	if (role === 6) {
		kickOutDetail = {
			groupAdminEmail: (clientPolicy && clientPolicy.company && clientPolicy.company.email) || "",
			groupAdminPhone: (clientPolicy && clientPolicy.company && clientPolicy.company.phone) || "",
			groupAdminFullName: (clientPolicy && clientPolicy.company && clientPolicy.company.companyName) || "",
			strategyName: (clientPolicy && clientPolicy.strategy && clientPolicy.strategy.name) || "",
		};
	}

	const participantId: number = (participant && participant.id) || 0;
    // closure function for make payload
    const makePersonalDetailPayloadOnlyTouchedValues =  (values: any, setInitialValues: any, autoSave = false ,touched:any = {}) => {
       const payload = makePersonalDetailPayload(values, setInitialValues, autoSave, touched);
        // allow only touched to send in request of saving request
        let changedValuesFromInitValues = {}

        let touchedKeys =  Object.keys(touched)
        // comparison with initValues to check changes or not
        touchedKeys =  touchedKeys.filter((key)=> {
            if(personalDetailForm.current.values[key] !== initialValues[key]){
                // comparison on objects
                return !(typeof initialValues[key] == "object" && JSON.stringify(initialValues[key]) === JSON.stringify(personalDetailForm.current.values[key]));
            }
        })
        touchedKeys.forEach(key => {
            changedValuesFromInitValues[key] = payload[key];
        })
        return changedValuesFromInitValues;
    }
	const makePersonalDetailPayload = (values: any, setInitialValues: any, autoSave = false, touched:any = {}) => {
		if (isCorporation && !values["fullTimeEmployee"] && !isFromClientDetail) {
			setOpenKickOutPopup(true);
			return false;
		}
		delete values["employerContribution"];
		setIsFormSubmit(true);
		if (!isFromClientDetail && proofExpired) {
			return false;
		}

		if (setInitialValues && typeof setInitialValues === "function") {
			setInitialValues(values);
		}

		if (role === 5 || role === 6) {
			delete values["contributionAmount"];
			delete values["healthType"];
		} else {
			values["contributionAmount"] = values["contributionAmount"] ? values["contributionAmount"].split(",").join("") : 0;
		}
		if (!isFromClientDetail && values["age"] === 0 && !autoSave) {
			return false;
		}

		values["employedTime"] = values["employedTime"] ? values["employedTime"] : 0;
		values["employer"] = values["employer"] ? values["employer"] : "";
		values["annualIncome"] = values["indIncomeLastYearAnnualSalary"] && Number(values["indIncomeLastYearAnnualSalary"]) !== 0 ? values["indIncomeLastYearAnnualSalary"].split(",").join("") : null;
		values["annualIncome1"] = values["indIncome1YearsPriorAnnualSalary"] && Number(values["indIncome1YearsPriorAnnualSalary"]) !== 0 ? values["indIncome1YearsPriorAnnualSalary"].split(",").join("") : null;
		values["annualIncome2"] = values["indIncome2YearsPriorAnnualSalary"] && Number(values["indIncome2YearsPriorAnnualSalary"]) !== 0 ? values["indIncome2YearsPriorAnnualSalary"].split(",").join("") : null;
		values["householdAnnualIncome"] = convertToNumber(values["houseHoldIncomeLastYearAnnualSalary"]);
		values["householdNetWorth"] = convertToNumber(values["householdNetWorth"]);
		//values["spouseDUAIncome"] = convertToNumber(values["spouseDUAIncome"]);
		values["householdLiquidAssets"] = convertToNumber(values["householdLiquidAssets"]);
		values["householdAnnualExpenses"] = convertToNumber(values["householdAnnualExpenses"]);
		values["dob"] = asDbDateTimeFormat(values["dob"], DATE_FORMAT_DOB_SAVE);
		//income details field starts
		values["spouseIncome"] = convertToNumber(values["spouseIncome"]);
		incomeDetailsColArr.forEach((item) => {
			values[`${item}`] = values[`${item}`] ? values[`${item}`].split(",").join("") : null;
		}); //income details field end
		values["netWorth"] = convertToNumber(values["netWorth"]);
        values["cellPhone"] = convertToNumber(values["cellPhone"]);
        values["workPhoneNumber"] = convertToNumber(values["workPhoneNumber"]);
		values["homePhone"] = convertToNumber(values["homePhone"]);
		values["immigrationStatus"] = values["immigrationStatus"] ? values["immigrationStatus"] : "";
		values["state"] = stateValue;
		values["birthState"] = birthStateValue;
		values["applicationState"] = applicationStateValue;
        values["employeeIdState"] = employeeIdStateValue;
        values["birthCountry"] = birthCountryValue;
        values["currentResidenceCountry"] = currentResidenceCountryValue;
		return values;
	};
	const saveMe = async (values: any) => {
        let payload: any = makePersonalDetailPayload({ ...values}, setInitialValues, true);
        if(filterAutoSavePayload && typeof filterAutoSavePayload === "function") {
            payload = filterAutoSavePayload(payload, Object.keys(personalDetailForm.current.values).filter((key)=> {
                if(personalDetailForm.current.values[key] !== initialValues[key]){
                    // comparison on objects
                    return !(typeof initialValues[key] == "object" && JSON.stringify(initialValues[key]) === JSON.stringify(personalDetailForm.current.values[key]));
                }
            }));
        }
		try {
			if (payload) {
				payload.age = Number(payload.age);
                if (payload.currentlyEmployed === "HOME_MAKER" || payload.currentlyEmployed === "STUDENT" || payload.currentlyEmployed === OTHER_VALUE) {
                    payload.employer = "";
                    payload.employedTime = 0;
                    payload.occupationDetail = "";
                    payload.employerAddress = "";
                }
                payload.spouseIncome = ((payload.marriageStatus === "Single") && (payload.spouseIncome === "" || payload.spouseIncome === null)) ? "0" : payload.spouseIncome;
				await accountActions.updateUserBasicDetails(payload, ((clientPolicy && clientPolicy.id) || 0), "");
                if ((values.birthCountry === USA) && (client.birthCountry !== USA) || (values.birthCountry !== USA) && (client.birthCountry === USA)) {
                    await accountActions.getProfileDetails();
                }
			}
		} catch (e) {
			if (e && e.message == 422 && (typeof getClientDetail === "function")) {
				getClientDetail(urlClientId || 0, clientPolicy.id, ssnFlag);
				setServerError(true);
			}
			return false;
		}
	};

	return (
		<>
			{isGiCorpIncomeCond &&
				<IncomeAlert incomeAlertOpen={incomeAlertOpen} />
			}
			<KickOut participantId={participantId} isFromClientDetail={isFromClientDetail || false}
					 openKickOut={openKickOutPopup} setOpenKickOut={() => {
				setOpenKickOutPopup(!openKickOutPopup);
			}} {...kickOutDetail} />

			<PersonalDetailFormikContent
				initialValues={initialValues}
                    // autoSaveEnable only disable in enrollment-tab
				personalDetailSchema={autoSaveEnable ? personalDetailSchema : undefined}
				isCorporation={isCorporation}
				setOpenKickOutPopup={setOpenKickOutPopup}
				setIsFormSubmit={setIsFormSubmit}
				isFromClientDetail={isFromClientDetail}
				proofExpired={proofExpired}
				isNationalLife={isNationalLife}
				selfEmployed={selfEmployed}
				minAge={minAge}
				setInitialValues={setInitialValues}
				setNextStep={setNextStep}
				client={client}
				setActionItem={setActionItem}
				role={role}
				setIsPersonalFormDirty={setIsPersonalFormDirty}
				setIsFormSubmitting={setIsFormSubmitting} setFullTimeEmployee={setFullTimeEmployee}
				fullTimeEmployee={fullTimeEmployee}
				setIncomeAlertOpen={setIncomeAlertOpen} setCurrentlyEmployed={setCurrentlyEmployed}
				setValidationError={setValidationError} setSelfEmployed={setSelfEmployed}
				accountActions={accountActions}
				setOpenAlert={setOpenAlert}
				user={user}
				fieldObj={fieldObj}
				clientSigned={clientSigned}
				conditionalRequired={conditionalRequired}
				CommonField={CommonField}
				fieldObj1={fieldObj1} fieldObj8={fieldObj8} classes={classes} fieldObj2={fieldObj2}
				proofExpireRef={proofExpireRef} fieldObj4={fieldObj4} fieldObj7={fieldObj7}
				fieldObj9={fieldObj9} fieldObj14={fieldObj14}
				strategySlug={strategySlug} fieldObj3={fieldObj3} fieldObj6={fieldObj6}
				clientDetail={props.clientDetail} showClientContribution={showClientContribution}
				showEmployerContribution={showEmployerContribution} minVal={minVal}
				personalDetailSubmit={personalDetailSubmit}
				setFullTimeSelected={setFullTimeSelected}
				fullTimeSelected={fullTimeSelected}
				setIsDocumentAddress={setIsDocumentAddress}
				setIsMarried={setIsMarried}
				setIsEmployed={setIsEmployed}
				isAllianzLife={isAllianzLife}
				setIsParentEarner={setIsParentEarner}
				isParentEarner={isParentEarner}
				personalDetailForm={personalDetailForm}
                // autoSaveEnable only disable in enrollment-tab
				makePersonalDetailPayload={autoSaveEnable ? makePersonalDetailPayload : makePersonalDetailPayloadOnlyTouchedValues}
				sendSaveRequest={sendSaveRequest}
				getClientDetail={getClientDetail}
				urlClientId={urlClientId}
				ssnFlag={ssnFlag}
				setServerError={setServerError}
				serverError={serverError}
				setAnticipatedAge={setAnticipatedAge}
				currentlyEmployed={currentlyEmployed}
                saveMe={saveMe}
				greenCardExpiryFieldObj={greenCardExpiryFieldObj}
                visaExpiryFieldObj={visaExpiryFieldObj}
			/>
			<AllianzAlert setOpenAlert={setOpenAlert} open={openAlert} carrierName={carrierName}
						  isNationalLife={isNationalLife} />
			{
				provideCorrectEmailPopUp &&
				<UpdateEmailReqPopUp open={provideCorrectEmailPopUp}
									 setProvideCorrectEmailPopUp={setProvideCorrectEmailPopUp} />
			}
		</>);
};

export default PersonalDetailFormV2;